export default {
  find: (state) => state.find,
  read: (state) => state.read,
  textSelect: (state) => state.textSelect,
  type: (state) => state.type,
  isTextSelected: (state) => state.isTextSelected,
};
